import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Template = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M14.386 2a1.6 1.6 0 0 1 1.6 1.6v10.786a1.6 1.6 0 0 1-1.6 1.6H3.6a1.6 1.6 0 0 1-1.6-1.6V3.6A1.6 1.6 0 0 1 3.6 2Zm0 1.2H3.6a.4.4 0 0 0-.4.4v10.786c0 .22.18.4.4.4h10.786a.4.4 0 0 0 .399-.4V3.6a.4.4 0 0 0-.4-.4m-1.218 8.774a.6.6 0 0 1 .097 1.192l-.097.008H4.797a.6.6 0 0 1-.098-1.192l.098-.008zm0-3.489a.6.6 0 0 1 .097 1.192l-.097.008h-2.582a.6.6 0 0 1-.097-1.192l.097-.008zm-4.64-3.44a.6.6 0 0 1 .593.503l.008.097v.764a.6.6 0 0 1-1.192.098l-.008-.098-.001-.164h-.63v2.24h.37a.6.6 0 0 1 .098 1.192l-.097.008H5.762a.6.6 0 0 1-.097-1.192l.097-.008h.337v-2.24h-.703v.164a.6.6 0 0 1-.502.592l-.097.008a.6.6 0 0 1-.592-.502l-.008-.098v-.764a.6.6 0 0 1 .503-.592l.097-.008zm4.64 0a.6.6 0 0 1 .097 1.193l-.097.008h-2.582a.6.6 0 0 1-.097-1.193l.097-.007z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Template$1 = Svg18Template;

export { Svg18Template$1 as default };
